<template>
  <li v-if="href" class="w-1/2 lg:w-1/4 px-4 mb-8">
    <VuepalLink
      :to="href"
      class="block group border-1 border-lightGreen p-3 sm:p-8 rounded-md bg-white drop-shadow-[0_4px_30px_0px_rgba(0,0,0,0.25)]"
    >
      <div class="flex flex-col items-center">
        <div
          class="size-32 md:size-54 bg-[#DAFAD5] rounded-full flex items-center justify-center mb-8 sm:mb-10"
        >
          <MediaIcon
            v-if="icon"
            v-bind="icon"
            class="size-[100px] fill-darkGreen text-darkGreen group-hover:text-violet lg:size-[135px] px-2 sm:px-0"
          />
          <SpriteSymbol
            v-else
            name="paperplane"
            alt="AOZ logo"
            class="size-[100px] fill-darkGreen text-darkGreen group-hover:text-violet lg:size-[135px] px-2 sm:px-0"
          />
        </div>
      </div>

      <div
        class="text-xs sm:text-lg font-book lg:font-bold lg:text-xl flex flex-row justify-between items-center text-darkGreen group-hover:text-violet"
      >
        <span>{{ label }}</span>
        <SpriteSymbol
          name="arrow-right"
          class="size-6 text-darkGreen transition-all duration-250 ease-in-out sm:mr-1 sm:group-hover:mr-0 group-hover:text-violet"
        />
      </div>
    </VuepalLink>
  </li>
</template>

<script lang="ts" setup>
import type { MediaIconFragment } from '#graphql-operations'

defineProps<{
  href?: string
  label?: string
  icon?: MediaIconFragment
}>()

defineOptions({
  name: 'MenuListLandingItem',
})
</script>
